// =============================================================================
// ENVIRONMENT CONFIGURATION - LOCAL, BETA, PROD
// =============================================================================

// Environment variables
const ENVIRONMENT = process.env.NODE_ENV || 'development';
const CUSTOM_API_URL = process.env.REACT_APP_API_URL;
const CUSTOM_DOMAIN = process.env.REACT_APP_DOMAIN;
const BUILD_ENV = process.env.REACT_APP_BUILD_ENV || 'local';

// Domain configuration for 3 environments
const DOMAINS = {
  local: {
    api: 'http://192.168.137.1:8080',
    frontend: 'http://localhost:3000'
  },
  beta: {
    api: 'https://ylived-beta.up.railway.app',
    frontend: 'https://beta.ylived.com'
  },
  prod: {
    api: 'https://ylived-production.up.railway.app',
    frontend: 'https://ylived.com'
  }
};

// Get current domain configuration
const getCurrentDomain = () => {
  // Priority: Custom URL > Build Environment > Node Environment mapping
  if (CUSTOM_API_URL) {
    return {
      api: CUSTOM_API_URL,
      frontend: CUSTOM_DOMAIN ? `https://${CUSTOM_DOMAIN}` : window.location.origin
    };
  }
  
  // Map NODE_ENV to our 3 environments
  let envKey = BUILD_ENV;
  if (!DOMAINS[envKey]) {
    envKey = ENVIRONMENT === 'production' ? 'prod' : 
             ENVIRONMENT === 'development' ? 'local' : 'beta';
  }
  
  return DOMAINS[envKey] || DOMAINS.local;
};

// Export configuration
const config = getCurrentDomain();

export const BASE_URL = `${config.api}/`;
export const FRONTEND_URL = config.frontend;
export const API_URL = config.api;
export const ENVIRONMENT_NAME = BUILD_ENV;
export const NODE_ENV = ENVIRONMENT;

// =============================================================================
// CHANNEL CONFIGURATION
// =============================================================================

// Channel detection from current route
export const getCurrentChannel = () => {
  if (typeof window === 'undefined') return 'default';

  const path = window.location.pathname || '/';
  const segments = path.split('/').filter(Boolean);
  // Expect pattern: /:lang/:channel
  const langs = ['en', 'ar', 'my'];
  if (segments.length >= 2 && langs.includes(segments[0])) {
    return segments[1] || 'default';
  }
  // If only /:lang selected or root, fall back to default
  return 'default';
};

// When the URL contains ?global=1, we keep the visual/channel context from
// the route but send channel=global specifically for list endpoints.
export const getListApiChannel = () => {
  try {
    const qs = new URLSearchParams(window.location.search || '');
    const forceGlobal = qs.get('global') === '1';
    if (forceGlobal) return 'global';
  } catch (_) { /* ignore */ }
  return getCurrentChannel();
};

export const CURRENT_CHANNEL = getCurrentChannel();

// Additional configuration
export const CONFIG = {
  api: {
    timeout: 10000,
    retries: 3,
    baseUrl: config.api
  },
  stripe: {
    enabled: process.env.REACT_APP_STRIPE_ENABLED !== 'false'
  },
  features: {
    maintenance: process.env.REACT_APP_MAINTENANCE_MODE === 'true',
    analytics: process.env.REACT_APP_ANALYTICS_ENABLED !== 'false',
    debug: BUILD_ENV === 'local',
    // If true, will allow analytics events even from normally blocked locations (localhost / Lebanon)
    allowBlockedAnalytics: process.env.REACT_APP_ALLOW_BLOCKED_ANALYTICS === 'true',
    // TikTok pixel enable flag (default on unless explicitly set false)
    tiktok: process.env.REACT_APP_TIKTOK_ENABLED !== 'false'
  },
  environments: {
    current: BUILD_ENV,
    available: Object.keys(DOMAINS)
  },
  channels: {
    current: getCurrentChannel(),
    available: ['default', 'usa', 'malaysia', 'philippines', 'iraq', 'ksa', 'uae', 'uk'],
    default: 'default'
  }
};
